<template>
  <div class="addApplicationForVehicle">
    <div class="newsDetial-header">
      <template v-if="!id">
        <div class="newsDetial-title">新建表单</div>
        <blank height="15"> </blank>
        <div class="newsDetial-abstract">
          请按照文本要求添加表单，并提交进行流程审批
        </div>
        <!-- <blank height="45"> </blank> -->
      </template>
      <div slot="title" class="card-title">
        <div class="newsDetial-title mb10" v-if="proQueryParams.showApproveBtn">
          取暖费报销详情
        </div>
        <div
          class="newsDetial-title mb10"
          v-if="tabnum == 1 && this.$route.query.operateType == 'check'"
        >
          取暖费报销详情
        </div>
        <div
          class="newsDetial-title mb10"
          v-if="tabnum == 2 && this.$route.query.operateType == 'check'"
        >
          取暖费报销审批流程
        </div>

        <!-- <span class="mr10"
              >{{ baseInfo.year }}第{{
                baseInfo.batch ? baseInfo.batch : 1
              }}批次</span
            > -->
        <div class="state1" v-if="Form.state == 1">审批中</div>
        <div class="state2" v-if="Form.state == 2">已归档</div>
        <div class="state3" v-if="Form.state == 3">退回</div>
        <div class="state4" v-if="Form.state == 4">取消</div>
        <!-- <template v-for="(item, index) in $store.state.app.formStatusList">
          <div
            :class="'state' + baseInfo.state"
            v-if="baseInfo.state == item.value"
            :key="index"
          >
            {{ item.label }}
          </div>
        </template> -->
      </div>
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="1" tab="表单详情" v-if="operateType != 'add'" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="Form.state > 0" />
      </a-tabs>
    </div>
    <!-- 页面内容 -->
    <div class="detial-cont" v-if="tabnum == 1">
      <template v-if="currentTab == 1">
        <!-- 基本信息 -->
        <div class="detial-cont-title">
          基本信息
          <!-- {{ baseInfo.organizationId }} -->
        </div>
        <blank height="1"> </blank>
        <div class="detial-cont-view">
          <a-descriptions layout="vertical">
            <a-descriptions-item>
              <span slot="label"
                >部门/单位<span class="required">*</span>
              </span>
              <a-tooltip placement="topLeft" :title="baseInfo.organizationName">
                <div>
                  <a-tree-select
                    v-model="baseInfo.organizationId"
                    :value="baseInfo.organizationName"
                    :label="baseInfo.organizationName"
                    class="w300"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :tree-data="organizationUserList"
                    placeholder="请选择部门"
                    tree-default-expand-all
                    :replaceFields="replaceFields"
                    @change="getUserListFn"
                    :disabled="disabled"
                  >
                  </a-tree-select>
                  <!-- <a-cascader
                    class="w300"
                    v-model="baseInfo.organizationId"
                    :options="organizationUserList"
                    placeholder="请选择"
                    :fieldNames="{
                      label: 'organizationName',
                      value: 'id',
                      children: 'treeList'
                    }"
                    @change="getUserListFn"
                    :disabled="disabled"
                  /> -->
                </div>
              </a-tooltip>
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label"
                >报销职工姓名<span class="required">*</span>
              </span>
              <!-- userName -->
              <a-input
                style="width: 215px"
                placeholder="请选择报销职工"
                v-model="baseInfo.fullName"
                :disabled="true"
              />
              <!-- userName -->
              <a-button
                type="primary"
                class="ml20"
                @click="selectUserFn"
                :disabled="disabled"
              >
                选择
              </a-button>

              <!-- <a-select
                placeholder="请添加"
                class="w300"
                :filter-option="filterOption"
                v-model="baseInfo.fullName"
                :disabled="disabled"
                @change="selecktUser"
              >
                <a-select-option
                  v-for="(i, index) in userList"
                  :value="i.fullName"
                  :key="index"
                  >{{ i.fullName }}</a-select-option
                >
              </a-select> -->
              <!-- <a-select
                v-model="baseInfo.fullName"
                show-search
                placeholder="请选择"
                class="w300"
                @change="selecktUser"
                :disabled="disabled"
                :options="userList"
                :fieldName="{ label: 'fullName', value: 'id' }"
                :filter-option="
                  (input, option) => {
                    return (
                      option.value.toLowerCase().indexOf(input.toLowerCase()) >=
                      0
                    )
                  }
                "
              ></a-select> -->
            </a-descriptions-item>

            <a-descriptions-item v-if="type == 3">
              <span slot="label">代办人 <span class="required">*</span></span>
              <a-input
                v-if="!id"
                class="w300"
                v-model="$store.state.app.userInfo.fullName"
                :disabled="true"
              />
              <a-input
                v-if="id"
                class="w300"
                v-model="baseInfo.userName"
                :disabled="true"
              />
            </a-descriptions-item>

            <a-descriptions-item>
              <span slot="label">手机号码<span class="required">*</span> </span>
              <a-input
                class="w300"
                placeholder="请添加"
                v-model="baseInfo.phone"
                disabled
              />
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label"
                >身份证号码<span class="required">*</span></span
              >
              <a-input
                class="w300"
                placeholder="请添加"
                v-model="baseInfo.idCardNumber"
                :disabled="true"
              />
            </a-descriptions-item>
            <a-descriptions-item v-if="operateTye != 'add'">
              <span slot="label">申请时间</span>
              <a-date-picker
                :disabled="disabled"
                show-time
                class="w300"
                placeholder="请选择"
                v-model="baseInfo.applyTime"
                valueFormat="YYYY-MM-DD HH:mm:ss"
              />
            </a-descriptions-item>
            <a-descriptions-item>
              <!-- <span class="required">*</span>  -->
              <span slot="label">银行卡号</span
              ><a-input
                class="w300"
                placeholder="请添加"
                v-model="baseInfo.cardNumber"
                :disabled="true"
              />
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">健康状况<span class="required">*</span> </span>
              <a-input
                class="w300"
                placeholder="请添加"
                :value="getByTypeName(baseInfo.healthStatus, healthStatusList)"
                :disabled="true"
              />
            </a-descriptions-item>

            <a-descriptions-item>
              <span slot="label">发票数 </span>
              <!-- v-model="invoiceCount" -->
              <!-- baseInfo.enableNum -->
              <a-input
                class="w300"
                placeholder="请添加"
                v-model="invoiceCount"
                disabled
              />
            </a-descriptions-item>

            <a-descriptions-item>
              <span slot="label">发票类型 </span>
              <a-select
                allowClear
                placeholder="请选择"
                class="w300"
                :disabled="disabled"
                v-model="baseInfo.invoiceType"
              >
                <a-select-option
                  v-for="item in invoiceTypeList"
                  :value="Number(item.valuename)"
                  :key="item.id"
                  >{{ item.keyname }}</a-select-option
                >
              </a-select>
            </a-descriptions-item>

            <a-descriptions-item>
              <span slot="label">报销年度 </span>
              <a-select
                allowClear
                placeholder="请选择"
                class="w300"
                :disabled="disabled"
                v-model="baseInfo.reimbursementYear"
              >
                <a-select-option
                  v-for="(item, index) in reimbursementYearList"
                  :value="item"
                  :key="index"
                  >{{ item }}</a-select-option
                >
              </a-select>
            </a-descriptions-item>

            <!-- <a-descriptions-item>
              <span slot="label"> 核定报销类型 </span>
              <a-select
                allowClear
                placeholder="请选择"
                class="w300"
                :disabled="disabled"
                v-model="baseInfo.verificationReimbursementType"
                @change="getRateList(baseInfo.verificationReimbursementType, 1)"
              >
                <a-select-option
                  v-for="item in $store.state.bytype.warmReimbursementTypeList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.reimbursementGroup }}</a-select-option
                >
              </a-select>
            </a-descriptions-item> -->
            <!-- <a-descriptions-item>
              <span slot="label"> 核定报销比例 </span>
              <a-input
                v-model="baseInfo.verificationProportion"
                class="w300"
                placeholder="请添加"
                :disabled="disabled"
              />
            </a-descriptions-item> -->
            <a-descriptions-item>
              <span slot="label">票证金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder="请添加"
                v-model="baseInfo.verificationFee"
              />
            </a-descriptions-item>

            <a-descriptions-item>
              <span slot="label">补贴金额（元） </span>
              <a-input
                :disabled="disabled"
                class="w300"
                placeholder="请添加"
                v-model="baseInfo.verificationFinalFee"
              />
            </a-descriptions-item>
            <a-descriptions-item>
              <span slot="label">备注 </span>
              <a-textarea
                auto-size
                :disabled="disabled"
                class="w300"
                placeholder="请添加"
                v-model="baseInfo.description"
              />
            </a-descriptions-item>
          </a-descriptions>
        </div>
        <!-- 房本附件 -->
        <blank height="20"> </blank>
        <div class="detial-cont-title">房本附件</div>
        <blank height="1"></blank>
        <div class="detial-cont-view">
          <premises-permit
            v-model="warmOneselfFileList1"
            :file="warmOneselfFileList1"
            :disabled="disabled"
            :id="id"
          ></premises-permit>
        </div>
        <!-- 残疾证附件 -->
        <blank height="20"> </blank>
        <div class="detial-cont-title">残疾证附件</div>
        <blank height="1"></blank>
        <div class="detial-cont-view">
          <disability-certificate
            v-model="warmOneselfFileList2"
            :file="warmOneselfFileList2"
            :disabled="disabled"
            :id="id"
          ></disability-certificate>
        </div>
        <!-- 供暖费发票附件 -->
        <blank height="20"> </blank>
        <div class="detial-cont-title">
          <span>供暖费发票附件</span>
          <!-- <a-button type="link" v-if="id" @click="lookList(1)">
            查看更多
          </a-button> -->
        </div>
        <blank height="1"></blank>
        <div class="detial-cont-view">
          <warm-invoice
            v-model="warmOneselfReimbursementAttachmentList"
            :file="warmOneselfReimbursementAttachmentList"
            :disabled="disabled"
            :id="id"
          ></warm-invoice>
        </div>
        <!-- 底部操作按钮 -->
        <!-- <bottomSuspension>
          <a-button :style="{ marginRight: '20px' }" @click="goback">
            返回
          </a-button>
          <a-button
            :loading="preserveLoading"
            type="primary"
            class="orange-btn"
            @click="preserveFn"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            :loading="submitLoading"
            type="primary"
            :style="{ marginRight: '20px' }"
          >
            审批
          </a-button>
        </bottomSuspension> -->
      </template>
      <template v-if="currentTab == 2"> 审批流内容 </template>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <!-- 审批流 表单流程 -->
        <keep-alive>
          <approvalChart
            ref="refChart"
            :approvalChartData="approvalChartData"
          ></approvalChart>
        </keep-alive>
      </div>
    </div>
    <!-- 审批流审批弹窗 -->
    <approvalSubmission v-model="isActivitiMode"></approvalSubmission>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <!-- form:{{ Form }},proQueryParams:{{ proQueryParams }} -->
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 2"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="confirmLoading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            v-if="!Form.state && !disabled"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            提交
          </a-button>
          <a-button
            v-if="proQueryParams.showApproveBtn === '1'"
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '20px' }"
            @click="submitFn"
          >
            {{ Form.state === 3 ? "提交" : "审批" }}
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <div v-if="proQueryParams.showApproveBtn === '1' ? true : false">
          <a-button
            v-if="Form.state === 3 ? true : false"
            type="danger"
            @click="cancelPro('2')"
            :style="{ marginRight: '20px' }"
          >
            删除
          </a-button>
        </div>
      </bottomSuspension>
    </template>

    <!-- 提示选择的人没有对应的信息 -->
    <a-modal
      :visible="visiblePerson"
      :width="400"
      title="提示"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>该员工没有身份证或银行卡信息</p>
      <p>请联系管理员进行信息导入</p>
    </a-modal>

    <!-- 选择人员弹窗 -->
    <a-modal
      :visible="visibleSelectUser"
      :width="600"
      title="请选择报销人员"
      @ok="handleOkSelectUser"
      @cancel="handleCancelSelectUser"
    >
      <a-input
        allowClear
        class="w300 mr20"
        placeholder="请输入报销人员"
        v-model="searchFullName"
      />
      <a-button type="primary" @click="collectionMit"> 查询</a-button>
      <blank height="20"> </blank>
      <a-table
        :pagination="false"
        :columns="columnsUser"
        :data-source="userList"
        :row-key="record => record.id"
        :row-selection="{
          onChange: onChange
        }"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ index + 1 + (page - 1) * 10 }}
        </span>
      </a-table>
      <div
        style="
          margin-top: 20px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        "
      >
        <a-pagination
          v-model="userPage"
          :defaultCurrent="userPage"
          :defaultPageSize="userSize"
          :total="userTotal"
          @change="userPageChange"
        />
      </div>
    </a-modal>
    <model-list
      ref="modelList"
      :id="id"
      :disabled="disabled"
      @updateDetails="getReimbursementDetailsFn"
    ></model-list>
  </div>
</template>

<script>
const columnsUser = [
  {
    title: "姓名",
    dataIndex: "fullName",
    key: "fullName",
    width: 100,
    align: "center"
  },
  {
    title: "手机号",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
    width: 100,
    align: "center"
  }
];

let myDate = new Date();
let reimbursementYearList = [
  `${myDate.getFullYear() + 1}年度——${myDate.getFullYear() + 2}年度`,
  `${myDate.getFullYear()}年度——${myDate.getFullYear() + 1}年度`,
  `${myDate.getFullYear() - 1}年度——${myDate.getFullYear()}年度`,
  `${myDate.getFullYear() - 2}年度——${myDate.getFullYear() - 1}年度`,
  `${myDate.getFullYear() - 3}年度——${myDate.getFullYear() - 2}年度`,
  `${myDate.getFullYear() - 4}年度——${myDate.getFullYear() - 3}年度`,
  `${myDate.getFullYear() - 5}年度——${myDate.getFullYear() - 4}年度`
];
import approvalSubmission from "@/components/approval-submission/index";
import approvalChart from "@/components/approval-chart/index";
import { activitiSubmission } from "@/utils/utils";
import { mapState, mapActions } from "vuex";
import { validateIdCard } from "@/assets/js/auth";
import {
  getReimbursementDetails,
  getOrganizationList,
  getUserList,
  warmOneselfReimbursementUpdate,
  warmOneselfReimbursementSave
} from "./api/api";
import PremisesPermit from "./components/premises-permit.vue";
import DisabilityCertificate from "./components/disability-certificate.vue";
import WarmInvoice from "./components/warm-invoice.vue";
import { queryLoginUser } from "@/http/url";
import modelList from "./components/model-list.vue";
export default {
  components: {
    PremisesPermit,
    DisabilityCertificate,
    WarmInvoice,
    approvalSubmission,
    approvalChart,
    modelList
  },
  // props: [
  //   'operateTye' // add-新增  edit-编辑  check-查看
  // ],
  data() {
    return {
      // 审批流部分
      // disabled: true,
      isActivitiMode: {
        isActivitiShow: false,
        proQueryParams: []
      },
      proQueryParams: [],
      pIsedit: "",
      Form: {},
      tabnum: "1", // 1表单页面， 2审批流页面
      confirmLoading: false,
      loading: false,
      id: "",
      approvalChartData: [],
      // 审批流部分
      replaceFields: {
        key: "id",
        value: "id",
        children: "treeList",
        title: "organizationName"
      },
      operateTye: "add",
      type: 2, // 表单类型
      id: null,
      currentTab: "1",
      userList: [],
      organizationUserList: [],
      baseInfo: {}, // 基本信息
      recipeList: null, // 底方附件
      outpatientDepList: null, // 门诊发票附件
      hospitalList: null, // 住院发票附件
      preserveLoading: false,
      submitLoading: false,
      invoiceCount: 0, // 发票数
      hospitalPay: 0, // 住院自付费用总额
      batchResList: [], // 批次列表
      warmOneselfFileList1: [], // 房本附件
      warmOneselfFileList2: [], // 残疾证
      warmOneselfReimbursementAttachmentList: [], // 发票
      reimbursementYearList,
      operateType: "", //当前页面是改 查 增
      visiblePerson: false,
      visibleSelectUser: false,
      columnsUser, // 人员弹窗列
      userPage: 1,
      userSize: 5,
      userTotal: 0,
      userIds: [],
      searchFullName: "",
      invoiceType: ""
    };
  },
  computed: {
    ...mapState(["app"]),
    ...mapState({
      invoiceTypeList: state => state.bytype.invoiceTypeList,
      healthStatusList: state => state.bytype.healthStatusList //健康状况
    }),

    disabled() {
      // if (this.operateTye == 'add') {
      //   return false
      // } else if (this.operateTye == 'check') {
      //   return true
      // } else if (this.operateTye == 'edit') {
      //   if (!this.isEmpty(this.baseInfo.state) && this.baseInfo.state != 1) {
      //     return true
      //   } else {
      //     return false
      //   }
      // }
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false;
      } else {
        this.proQueryParams = this.$route.query;
        if (this.proQueryParams.isEdit) {
          if (
            this.proQueryParams.isEdit === "100" ||
            this.proQueryParams.isEdit === "1"
          ) {
            return true;
          } else {
            return false;
          }
        } else if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true;
        } else {
          // 草稿箱或退回状态  可编辑
          return false;
        }
      }
    }
  },
  watch: {
    // 发票附件
    warmOneselfReimbursementAttachmentList: {
      handler(val) {
        this.getInvoiceCount();
        if (!this.isEmpty(val)) {
          this.baseInfo.verificationFee = 0;
          if (!this.isEmpty(this.baseInfo.verificationFee)) {
            this.baseInfo.verificationFee = Number(
              this.baseInfo.verificationFee
            ).toFixed(2);
          } else {
            this.baseInfo.verificationFee = 0;
          }
          val.forEach(item => {
            if (!this.isEmpty(item["fee"])) {
              this.baseInfo.verificationFee += Number(item["fee"]);
            }
          });

          this.baseInfo.verificationFee = this.baseInfo.verificationFee.toFixed(
            2
          );
        }
      },
      deep: true
    }
  },
  created() {
    this.queryLoginUserFn();
    this.getByType();
    this.id = this.$route.query.id ? this.$route.query.id : "";
    if (this.$route.query.operateTye) {
      this.operateTye = this.$route.query.operateTye;
    }
    // 申请时间默认为当前时间
    this.baseInfo.applyTime = this.timeToStr();
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    this.getOrganizationListFn();
    // 报销类型
    if (!this.id) {
      this.$store.dispatch("getReimbursementTypeFn", {
        type: 1,
        workersType: this.$route.query.type
      });
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      // 查询详情  回显
      this.getReimbursementDetailsFn();
    }
    if (this.$route.query.operateType) {
      this.operateType = this.$route.query.operateType;
    }
  },
  methods: {
    // 获取用户信息
    queryLoginUserFn() {
      queryLoginUser().then(res => {
        if (res.data.code == 0) {
          this.$store.commit("set_userInfo", res.data.data);
        }
      });
    },
    //通过字典值过去字典名
    getByTypeName(value, list) {
      if (!value) {
        return;
      }
      let byType = list.find(item => {
        return item.valuename == value;
      });
      if (byType) {
        return byType.keyname;
      } else {
        return value;
      }
    },
    ...mapActions(["getInvoiceTypeList", "gethealthStatus"]),
    // 获取当前页面所需字典表
    getByType() {
      // 取暖费发票类型
      this.getInvoiceTypeList();
    },
    // 多选搜索按名字搜
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 时间格式处理
    timeToStr() {
      let timestamp = Date.now();
      var date = new Date(timestamp);
      var Y = date.getFullYear() + "-";
      var M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      var D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      var h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      var m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      var s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    // 选择报销类型
    getRateList(reimbursementGroup, type) {
      this.$store.dispatch("getReimbursementTypeFn", {
        type: type,
        workersType: this.$route.query.type || this.baseInfo.type,
        reimbursementGroup: reimbursementGroup
      });
      let arr = this.$store.state.bytype.warmReimbursementTypeList.filter(
        item => {
          return (reimbursementGroup = item.reimbursementGroup);
        }
      )[0];

      this.baseInfo.verificationProportion = arr["proportion"];
    },
    // 计算发票数量
    getInvoiceCount() {
      this.invoiceCount = 0;
      let warmOneselfReimbursementAttachmentListLen = 0;
      if (!this.isEmpty(this.warmOneselfReimbursementAttachmentList)) {
        warmOneselfReimbursementAttachmentListLen = this
          .warmOneselfReimbursementAttachmentList.length;
      }
      this.invoiceCount = Number(warmOneselfReimbursementAttachmentListLen);
    },
    // 提交
    submitFn() {
      // this.Form.state === 0 未进入审批流
      // <0 已经进入审批流
      // this.Form.draft = 1 == 进入草稿箱
      // this.Form.draft = 2 == 发起审批流
      if (this.Form.state > 0) {
        this.Form.draft = 2;
        this.confirmSaveEdit("保存修改");
      } else {
        this.$confirm({
          title: "确定提交吗?",
          okType: "danger",
          onOk: () => {
            this.Form.draft = 2;
            this.confirmSaveEdit("提交");
          }
        });
      }
    },
    // 保存
    preserveFn(type) {
      // draft == 1 保存
      if (type === "0") {
        // 自定义保存判断 1 = 仅保存
        this.pIsedit = "1";
        this.Form.draft = 2;
      } else {
        this.pIsedit = "2";
        this.Form.draft = 1;
      }
      // 新增添加方法
      this.confirmSaveEdit("保存");
    },
    // 修改基本信息
    confirmSaveEdit(type) {
      if (this.isEmpty(this.baseInfo.organizationId)) {
        this.$message.error("请输入部门/单位");
        return false;
      }
      if (this.isEmpty(this.baseInfo.fullName)) {
        this.$message.error("请输入报销职工名称");
        return false;
      }
      if (
        !this.isEmpty(this.baseInfo.idCardNumber) &&
        !validateIdCard(this.baseInfo.idCardNumber)
      ) {
        this.$message.error("请输入正确格式的身份证号码");
        return false;
      }

      // if (this.isEmpty(this.baseInfo.cardNumber)) {
      //   this.$message.error('请联系管理员维护银行卡号')
      //   return false
      // }
      let organizationId = "",
        verificationReimbursementType = "";
      if (!this.isEmpty(this.baseInfo.organizationId)) {
        organizationId = this.baseInfo.organizationId[
          this.baseInfo.organizationId.length - 1
        ];
      }
      if (!this.isEmpty(this.baseInfo.verificationReimbursementType)) {
        verificationReimbursementType = this.baseInfo
          .verificationReimbursementType;
      }
      let params = {
        // applyTime: this.baseInfo.applyTime,
        appId: this.$route.meta.appId,
        skipPageReqFlag: "/HeatingFeeDetail",
        cardNumber: this.baseInfo.cardNumber,
        draft: this.Form.draft,
        idCardNumber: this.baseInfo.idCardNumber,
        organizationId: organizationId,
        phone: this.baseInfo.phone,
        state: this.baseInfo.state,
        type: this.type,
        verificationFee: this.baseInfo.verificationFee,
        verificationFinalFee: this.baseInfo.verificationFinalFee,
        verificationProportion: this.baseInfo.verificationProportion,
        verificationReimbursementType: verificationReimbursementType,
        warmOneselfFileList1: this.warmOneselfFileList1,
        warmOneselfFileList2: this.warmOneselfFileList2,
        warmOneselfReimbursementAttachmentList: this
          .warmOneselfReimbursementAttachmentList,

        organizationId: this.baseInfo.organizationId,
        userId: this.baseInfo.userId,
        invoiceType: this.baseInfo.invoiceType
          ? Number(this.baseInfo.invoiceType)
          : null,
        reimbursementYear: this.baseInfo.reimbursementYear,
        enableNum: this.invoiceCount,
        description: this.baseInfo.description,
        healthStatus: this.baseInfo.healthStatus
      };
      // let apiName
      // if (this.operateTye == 'add') {
      //     apiName = warmOneselfReimbursementSave
      //   } else {
      //     params.id = this.id
      //     apiName = warmOneselfReimbursementUpdate
      //   }
      //   apiName(params).then((res) => {
      //     if (res.data.code == 0) {
      //       this.$message.success('操作成功')
      //     }
      //   })
      if (this.id) {
        params.id = this.id;
        warmOneselfReimbursementUpdate(params).then(res => {
          if (res.data.code == 0) {
            if (this.pIsedit === "1") {
              this.$message.success("操作成功");
              this.pIsedit = "";
            } else {
              if (this.Form.state > 0) {
                this.getReimbursementDetailsFn();
                // 合并 保存+审批流操作
                if (
                  this.proQueryParams.showApproveBtn === "1" &&
                  this.Form.state != "3"
                ) {
                  this.approvalPro();
                } else {
                  this.cancelPro("1");
                }
                // this.$message.success('修改成功')
                // 合并 保存+审批流操作
              } else {
                if (this.Form.draft == 2) {
                  this.goback();
                }
                this.$message.success("操作成功");
              }
            }
            this.loading = false;
            this.confirmLoading = false;
          } else {
            this.loading = false;
            this.confirmLoading = false;
          }
        });
      } else {
        params.userName = this.$store.state.app.userInfo.fullName;
        params.fullName = this.baseInfo.fullName;
        warmOneselfReimbursementSave(params).then(res => {
          if (res.data.code == 0) {
            this.$message.success("操作成功");
            if (this.Form.draft == 2) {
              this.goback();
            } else {
              //首次添加
              this.id = res.data.data;
              this.getReimbursementDetailsFn();
            }
            this.loading = false;
            this.confirmLoading = false;
          } else {
            this.loading = false;
            this.confirmLoading = false;
          }
        });
      }
    },
    // 获取报销详情
    getReimbursementDetailsFn() {
      getReimbursementDetails({ id: this.id }).then(res => {
        if (res.data.code == 0) {
          this.Form = res.data.data;
          this.baseInfo = res.data.data;
          this.type = res.data.data.type;
          if (this.isEmpty(this.baseInfo.verificationReimbursementType)) {
            this.baseInfo.verificationReimbursementType = [];
          }
          this.batchResList = res.data.data.batchResList;
          this.warmOneselfFileList1 = res.data.data.warmOneselfFileList1;
          this.warmOneselfFileList2 = res.data.data.warmOneselfFileList2;
          this.warmOneselfReimbursementAttachmentList =
            res.data.data.warmOneselfReimbursementAttachmentList;

          // 多个对象合并合并多个
          let processInstanceId = {
            processInstanceId: res.data.data.processInstanceId,
            detailsData: res.data.data
          };
          Object.assign(this.proQueryParams, processInstanceId);
          // 报销比例
          this.getRateList(this.baseInfo.verificationReimbursementType, 1);
        }
      });
    },
    // 审批流取消
    cancelPro(key) {
      switch (key) {
        case "1":
          // 提交
          this.$confirm({
            title: "您是否提交?",
            onOk: () => {
              activitiSubmission(this.proQueryParams, "1", this);
            },
            onCancel: () => {
              // console.log('Cancel')
            }
          });
          break;
        case "2":
          // 取消
          this.$confirm({
            title: "您是否删除?",
            onOk: () => {
              activitiSubmission(this.proQueryParams, "2", this);
            },
            onCancel: () => {
              // console.log('Cancel')
            }
          });
          break;

        default:
          break;
      }
    },
    // 切换审批流 表单流程
    tabClick(key) {
      if (key == 2) {
        this.approvalChartData = this.proQueryParams;
      } else {
        this.getReimbursementDetailsFn();
      }
    },
    approvalPro() {
      this.isActivitiMode = {
        isActivitiShow: true,
        proQueryParams: this.proQueryParams
      };
    },
    // 工作流结束
    // 返回
    goback() {
      this.$router.go(-1);
    },
    //  查看更多
    lookList(type) {
      this.invoiceType = type;
      this.$refs.modelList.setVisible();
    },
    // 查询报销员工
    getUserListFn(a, b, c) {
      // 赋值部门名称
      if (b) {
        this.baseInfo.departmentName = b[0] || "";
      }
      // let organizationId = ''
      // if (!this.isEmpty(this.baseInfo.organizationId)) {
      //   organizationId =
      //     this.baseInfo.organizationId[this.baseInfo.organizationId.length - 1]
      // }
    },

    // 部门单位列表
    getOrganizationListFn() {
      getOrganizationList().then(res => {
        if (res.data.code == 0) {
          this.organizationUserList = res.data.data;
        }
      });
    },
    // 更改报销职工
    selecktUser(e) {
      if (!this.isEmpty(e)) {
        let userInfo = this.userList.filter(item => {
          return e == item.fullName;
        })[0];
        this.baseInfo.phone = userInfo["phoneNumber"];
        this.baseInfo.idCardNumber = userInfo["idCardNumber"];
        this.baseInfo.cardNumber = userInfo["bankCardNumber"];
        // if (!userInfo.bankCardNumber || userInfo.bankCardNumber == null) {
        //   this.visiblePerson = true;
        // }
      } else {
        this.baseInfo.phone = "";
        // this.baseInfo.fullName = ''
        this.baseInfo.userName = "";
        this.baseInfo.idCardNumber = "";
        this.baseInfo.cardNumber = "";
      }
    },
    // 提示窗
    handleOk() {
      this.visiblePerson = false;
    },
    handleCancel() {
      this.visiblePerson = false;
    },
    selectUserFn() {
      if (
        !this.baseInfo.organizationId &&
        this.baseInfo.organizationId == null
      ) {
        this.$message.error("请先选择部门，再选择人员");
        return;
      }
      const params = {
        // dutiesVal: 'duties_type',
        fullName: this.searchFullName || "",
        organizationId: this.baseInfo.organizationId,
        page: this.userPage,
        size: this.userSize
      };
      getUserList(params).then(res => {
        if (res.data.code == 0) {
          this.searchFullName = "";
          this.userList = res.data.data;
          this.userTotal = res.data.count;
        }
      });
      this.visibleSelectUser = true;
    },
    // 选中之后点击确定
    handleOkSelectUser() {
      if (this.userIds.length > 1) {
        this.$message.error("只允许选择一个人");
        return;
      }

      if (this.userIds) {
        let userInfo = this.userList.filter(item => {
          return this.userIds == item.id;
        })[0];
        this.baseInfo.phone = userInfo["phoneNumber"];
        this.baseInfo.fullName = userInfo["fullName"];
        this.baseInfo.idCardNumber = userInfo["idCardNumber"];
        this.baseInfo.cardNumber = userInfo["bankCardNumber"];
        this.baseInfo.userId = userInfo["id"];
        this.baseInfo.healthStatus = userInfo["healthStatus"];
        this.visibleSelectUser = false;
        // if (!userInfo.bankCardNumber || userInfo.bankCardNumber == null) {
        //   this.visiblePerson = true;
        // }
      } else {
        this.baseInfo.phone = "";
        this.baseInfo.fullName = "";
        this.baseInfo.idCardNumber = "";
        this.baseInfo.cardNumber = "";
        this.baseInfo.userId = "";
        this.baseInfo.healthStatus = "";
      }
    },
    // 取消
    handleCancelSelectUser() {
      this.visibleSelectUser = false;
      this.userPage = 1;
      this.searchFullName = "";
    },
    // 只需监测发生变化 即可
    onChange(selectedRowKeys, selectedRows) {
      // this.userRowKeys = selectedRowKeys
      this.userIds = selectedRows.map(item => {
        return item.id;
      });
    },
    // 弹窗用户 分页
    userPageChange(pageNumber) {
      this.userPage = pageNumber;
      this.selectUserFn();
    },
    // 点击弹窗的 查询按钮
    collectionMit() {
      this.page = 1;
      this.selectUserFn();
    }
    // ...mapActions(['getcarApplicationTypeList', 'getorganizationUserList']),
  }
};
</script>

<style lang="scss" scoped>
.addApplicationForVehicle {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .detial-bottom {
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
// 打印内容不能嵌套写样式
.print-title {
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  height: 50px;
  line-height: 50px;
}
.card-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}
.card-item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/HeatingFee/detail.vue